import React from 'react';
import {  MuiGrid } from '../../ui/MaterialUIComponents';
import EventComponent from './EventComponent'

const arr = Array.apply(null, new Array(24)).map(function(el, i) {return ++i })
class TimeSlotComponent extends React.Component {
   getTableContent(){
   
    let timeArray = arr.map((element,index) => {
        let periodCell = '';
        if(this.props.timeSlot.blockletConfiguration != undefined){
          periodCell = this.props.timeSlot.blockletConfiguration.map((blocket)=>{
              if(element === blocket.startingBlocket){
                return <EventComponent blocket={blocket}
                {...this.props}/>
              }else{
                return '';
              }
          })

          
        }
        return <MuiGrid align='center' key={index} style={{ background: 'white', 
          position: 'relative', height: this.props.cellHeight+'px' }}>
            {periodCell}
            </MuiGrid>
    })

      return timeArray;
       
      
  } 
  render() {
    //const arr = Array.apply(null, new Array(24)).map(function(el, i) {return ++i })
    //const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,13,14,15,16,17,18,19,20,21,22,23,24]
    return (
        <MuiGrid style={{ display: 'flex', flexDirection: 'column', border: '1px solid lightGray' }}>
          {
          this.getTableContent()
      
        }
        </MuiGrid>
      
      )
  }
}

export default TimeSlotComponent;